import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-main-dark via-gray-800 to-black text-main-light py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          {/* Column 1: Quick Links */}
          <div>
            <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
              Quick Links
            </h3>
            <ul className="space-y-4 text-gray-400">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/advertising-portal">Advertisers</Link>
              </li>
              <li>
                <Link to="/franchise-page">Franchise</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/login">Login / Join</Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Top Categories */}
          <div>
            <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
              Help Categories
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-gray-400">
              {/* First 5 categories */}
              <ul className="space-y-4">
                {["Health", "Legal", "Education", "Jobs", "Business"].map(
                  (category, index) => (
                    <li key={index}>
                      <Link to={`/help/${category.toLowerCase()}`}>
                        {category}
                      </Link>
                    </li>
                  )
                )}
              </ul>

              {/* Next 5 categories */}
              <ul className="space-y-4">
                {["Finance", "Housing", "Family", "Fashion", "Community"].map(
                  (category, index) => (
                    <li key={index}>
                      <Link to={`/help/${category.toLowerCase()}`}>
                        {category}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>

          {/* Column 3: Partnership */}
          <div>
            <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
              Partnerships
            </h3>
            <ul className="space-y-4 text-gray-400">
              <li>
                <Link to="/exclusive-partnership">
                  Exclusive Partnership
                </Link>
              </li>
              <li>
                <Link to="/exclusive-partnership">
                  Become a Partner
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div>
            <h3 className="text-2xl font-bold font-barlow mb-6 border-b-2 border-main-green pb-2">
              Connect With Us
            </h3>
            <div className="mb-4">
              <p className="text-gray-400 mb-2">📩 Join Our Newsletter</p>
              <div className="flex items-center space-x-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-3 py-2 text-sm text-black rounded-md"
                />
                <button className="bg-main-green text-white px-4 py-2 rounded-md hover:bg-green-700 transition">
                  Join
                </button>
              </div>
            </div>
            <p className="text-gray-400 mt-6">Follow Us:</p>
            <div className="flex space-x-4 mt-2">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="hover:text-main-green"
              >
                Instagram
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="hover:text-main-green"
              >
                Facebook
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="hover:text-main-green"
              >
                LinkedIn
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="hover:text-main-green"
              >
                Twitter
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Strip */}
        <div className="mt-12 border-t border-gray-700 pt-6 text-center text-sm text-gray-500">
        Pink Help | Muhammad Usman © 2024
        </div>
      </div>
    </footer>
  );
};

export default Footer;
